import { Box, Text, HStack, VStack } from "@chakra-ui/react";
import { METRIPORT_PURPLE, METRIPORT_GREEN } from "../../../shared-logic/style";

interface NoteClassificationProps {
  noteCategory: string;
  specialty: string;
  typeOfReport?: string;
}

export function NoteClassification({
  noteCategory,
  specialty,
  typeOfReport,
}: NoteClassificationProps) {
  return (
    <VStack align="start" spacing={3} mb={4}>
      <HStack spacing={3}>
        <Text fontWeight="semibold" fontSize="sm" color="gray.600">
          Note Category:
        </Text>
        <Box
          bg={METRIPORT_PURPLE}
          color="white"
          px={3}
          py={1}
          borderRadius="md"
          fontSize="sm"
          fontWeight="semibold"
        >
          {noteCategory}
        </Box>
      </HStack>

      <HStack spacing={3}>
        <Text fontWeight="semibold" fontSize="sm" color="gray.600">
          Specialty:
        </Text>
        <Box
          bg={specialty === "Unknown" ? "gray.500" : METRIPORT_GREEN}
          color="white"
          px={3}
          py={1}
          borderRadius="md"
          fontSize="sm"
          fontWeight="semibold"
        >
          {specialty}
        </Box>
      </HStack>

      {typeOfReport && typeOfReport !== noteCategory && (
        <HStack spacing={3}>
          <Text fontWeight="semibold" fontSize="sm" color="gray.600">
            Original Type:
          </Text>
          <Text fontSize="sm" color="gray.500">
            {typeOfReport}
          </Text>
        </HStack>
      )}
    </VStack>
  );
}
